import React, { Component } from 'react'
import { connect } from 'react-redux'

import { invoiceOrder, approveOrderInvoice, markAsInvoiced, invoiceHistory } from '../../../actions/invoicing'
import { hasAccess } from '../../../utils/auth'
import Confirm from '../Confirm'
import store from '../../../store'
import ResendText from '../ActionMenu/OrderActions/ResendText'
import { translation } from '../../../utils/helpers'
import { InvoiceIcons } from '../../elements/icons'

// Elements
import Button from '../../elements/button'
import Icon from '../../elements/icon'
import Inline from '../../elements/inline'
// import Check from '../../elements/check'
import Label from '../../elements/label'
import Divider from '../../elements/divider'
import CloseButton from '../../elements/closeButton'
import { OrderTypes } from '../../../constants'

// Styles
import './invoicePopup.scss'

class InvoicePopup extends Component {
  constructor (props) {
    super(props)
    this.invoiceOrder = this.invoiceOrder.bind(this)
    this.approveInvoice = this.approveInvoice.bind(this)
    this.checkApproveInvoice = this.checkApproveInvoice.bind(this)
    this.markAsInvoiced = this.markAsInvoiced.bind(this)
    this.confirm = this.confirm.bind(this)
    this.confirmResend = this.confirmResend.bind(this)
    this.confirmAddon = this.confirmAddon.bind(this)
    this.notConfirm = this.notConfirm.bind(this)
    this.getLastHistory = this.getLastHistory.bind(this)
    this.onConfirmApprove = this.onConfirmApprove.bind(this)
    this.getKeyLoopSystemName = this.getKeyLoopSystemName.bind(this)
    this.getRepairOrderAlias = this.getRepairOrderAlias.bind(this)
    this.state = {
      splitAddon: props.item.SeparateAddonInvoice,
      isLoading: false,
      showPopup: false,
      showResendPopup: false,
      showAddonPopup: false,
      isInvoiced: false,
      lastHistory: null,
      FoundHistory: {
        Date: '0001-01-01T00:00:00',
        EconomicAddonInvoiceId: 0,
        EconomicInvoiceId: 0,
        EconomicKickbackInvoiceId: 0,
        FoundHistory: false,
        UserName: null
      },
      shouldMark: false,
      confirmApproveAssesment: {
        open: false
      }
    }
  }

  componentDidMount () {
    let isReady = !hasAccess([6], this.props.auth.user.UserType) && this.props.item.ReadyForInvoice === 1 || hasAccess([6], this.props.auth.user.UserType) && this.props.item.ReadyForInvoiceByWP
    let isInvoiced = !hasAccess([6], this.props.auth.user.UserType) && this.props.item.IsInvoiced || hasAccess([6], this.props.auth.user.UserType) && this.props.item.IsInvoicedByWP
    let isDraft = this.props.item.IsDraft

    this.getLastHistory()
  }

  getLastHistory (cb) {
    this.setState({
      isLoading: true
    }, () => {
      this.props.invoiceHistory(this.props.item.Id).then((res) => {
        this.setState({
          isLoading: false,
          lastHistory: res.data
        }, () => {
          // console.log('this.state.lastHistory', this.state.lastHistory)
          if (cb !== undefined) {
            cb()
          }
        })
      }, () => {
        this.setState({
          isLoading: false
        })
        if (cb !== undefined) {
          cb()
        }
      })
    })
  }
  invoiceOrder (markInvoiced, confirmed = false, addonChecked = false) {
    // console.log('[Invoice][invoiceOrder]')
    if (this.state.isLoading) return
    if (this.state.showResendPopup === true || this.state.showAddonPopup === true) {
      this.setState({
        showResendPopup: false,
        showAddonPopup: false
      })
    }
    if (this.state.lastHistory && this.state.lastHistory.FoundHistory === true && confirmed !== true) {
      this.setState({
        showResendPopup: true,
        shouldMark: markInvoiced === true
        // }, {  () => console.log('[Invoice]', this.state)
      })
      return null
    }
    if (this.props.item.HasAddonPrice && this.props.item.CanChangeAddonInvoice && !this.state.splitAddon && !addonChecked) {
      this.setState({
        showAddonPopup: true,
        shouldMark: markInvoiced === true
      })
      return null
    }
    let split = this.state.splitAddon
    let data = {
      OrderId: this.props.item.Id,
      SplitAddon: split,
      MarkAsInvoiced: markInvoiced === true
    }
    this.setState({ isLoading: true }, () => {
      // this.props.showSpinner('invoicing', true)
      this.props.invoiceOrder(data).then((res) => {
        let item = { ...this.props.item }
        item.IsInvoiced = true
        if (markInvoiced === true) {
          item.IsMarkInvoiced = true
        }
        this.props.updateOrder(item)
        // if (!confirmed) {
        //   this.props.close()
        // }
        this.props.showSpinner('invoicing', false)
        this.setState({ isLoading: false }, () => {
          this.props.close()
        })

        // Toastr
        // window.toastr.success(translation('13022'), translation('13424'))
      }, (err) => {
        this.props.close()
        this.props.showSpinner('invoicing', false)
        // Toastr
        if (err.response) {
          if (err.response.data !== undefined && err.response.data.Error !== undefined) {
            let error = err.response.data.Error
            let errorText = translation('960')
            // OrderNotFound = 1,
            // CompanyNotFound = 2,
            // NotValidEconomicCredentials = 3,
            // NotValidHeliosNumber = 4,
            // NotValidC5UserPass = 5,
            // OrderIsAlreadySent = 6,
            // AwaitingPriceApproval = 8
            switch (error) {
              case 0:
                errorText = translation('13700')
                break
              case 1:
                errorText = translation('13701')
                break
              case 2:
                errorText = translation('13702')
                break
              case 3:
                errorText = translation('13703')
                break
              case 4:
                errorText = translation('13704')
                break
              case 5:
                errorText = translation('13705')
                break
              case 6:
                errorText = translation('13706')
                break
              case 7:
                errorText = translation('13707')
                break
              case 8:
                errorText = translation('2710')
                break
              case 9:
                errorText = translation('14851')
                break
              case 10:
                errorText = translation('16616')
                break
              case 11:
                errorText = translation('16617')
                break
              case 12:
                errorText = translation('16650')
                break
              case 13:
                errorText = translation('16618')
                break
              case 14:
                errorText = translation('16636').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()).replace('[RepairOrderAlias]', this.getRepairOrderAlias())
                break
              case 15:
                errorText = translation('16651')
                break
              case 16:
                errorText = translation('16619').replace('[KeyLoopSystem]', this.getKeyLoopSystemName())
                break
              case 17:
                errorText = translation('17947')
                break
              case 18:
                errorText = translation('18145')
                break
              case 19:
                errorText = translation('18144')
                break
              default: break
            }
            window.toastr.error(errorText, translation('216'))
          } else {
            window.toastr.error(translation('960'), translation('216'))
          }
        } else {
          window.toastr.error(translation('960'), translation('216'))
        }
      })
    })
  }

  checkApproveInvoice (undo, checkForAfterEvaluation) {
    if (!undo && checkForAfterEvaluation && this.props.item.OrderType === OrderTypes.Insurance && this.props.item.LastUpdatedType === 1) {
      this.setState({
        showPopup: true
      })
      return
    }

    if (this.state.lastHistory && this.state.lastHistory.FoundHistory === true && this.props.item.IsAssessmentOk === false) {
      this.setState({
        confirmApproveAssesment: {
          open: !this.state.confirmApproveAssesment.open
        }
      }, () => {
      })
      return
    }
    this.approveInvoice(undo)
  }

  approveInvoice (undo) {
    if (this.state.confirmApproveAssesment.open === true) {
      this.setState({
        confirmApproveAssesment: {
          open: false
        }
      })
    }
    this.props.showSpinner('invoicing', true)
    this.props.approveOrderInvoice(this.props.item.Id, undo).then((res) => {
      let item = { ...this.props.item }
      item.ReadyForInvoice = res.data.ReadyForInvoice ? 1 : 0
      item.ReadyForInvoiceByWP = res.data.ReadyForInvoice
      item.IsAssessmentOk = res.data.ReadyForInvoice
      if (item.ReadyForInvoice) {
        item.InspectionStepsCompleted += 1
      }
      this.props.updateOrder(item)
      this.props.close()
      this.props.showSpinner('invoicing', false)
      // Toastr
      if (res.data.ReadyForInvoice) {
        // window.toastr.success(translation('13708'), translation('13424'))
      } else {
        // window.toastr.success(translation(15213), translation('13424'))
      }
    }, (err) => {
      this.props.close()
      this.props.showSpinner('invoicing', false)
      // Toastr
      if (err.response) {
        if (err.response.data !== undefined && err.response.data.Errors !== undefined && err.response.data.Errors.length === 1) {
          let error = err.response.data.Errors[0]
          let text = translation(error.DictionaryKey)
          if (error.Parameters.length === 1) {
            text = text.replace('[WorkProvider]', error.Parameters[0])
          }
          // console.log(err.response.data, error, text)
          window.toastr.error(text, translation('216'))
        } else if (err.response.status === 403) {
          window.toastr.error(translation('1794'), translation('216'))
        } else {
          window.toastr.error(translation('910'), translation('216'))
        }
      } else {
        window.toastr.error(translation('960'), translation('216'))
      }
    })
  }

  markAsInvoiced () {
    this.props.showSpinner('invoicing', true)
    this.props.markAsInvoiced(this.props.item.Id).then((res) => {
      let result = res.data
      let item = { ...this.props.item }
      item.IsMarkInvoiced = result.MarkInvoiced
      this.props.updateOrder(item)
      this.props.close()
      this.props.showSpinner('invoicing', false)

      // window.toastr.success(translation('13510'), translation('13424'))
    }, () => {
      this.props.close()
      this.props.showSpinner('invoicing', false)
      // Toastr
      window.toastr.error(translation('13650'), translation('216'))
    })
  }

  confirm () {
    this.setState({
      showPopup: false,
      showResendPopup: false
    }, () => {
      this.checkApproveInvoice(false)
    })
  }
  confirmResend (e) {
    e.stopPropagation()
    e.preventDefault()
    this.setState({
      showResendPopup: false
    }, () => { this.invoiceOrder(this.state.shouldMark === true, true) })
  }

  confirmAddon (val) {
    this.setState({
      splitAddon: val,
      showAddonPopup: false
    }, () => { this.invoiceOrder(this.state.shouldMark === true, true, true) })
  }

  // notConfirmAddon () {
  //   this.setState({
  //     splitAddon: false,
  //     showAddonPopup: false
  //   }, () => { this.invoiceOrder(this.state.shouldMark === true, true, true) })
  // }

  notConfirm () {
    this.setState({
      showPopup: false,
      showResendPopup: false,
      confirmApproveAssesment: {
        open: false
      }
    })
  }

  onConfirmApprove () {
    this.approveInvoice(false)
  }

  getKeyLoopSystemName () {
    switch (this.props.auth.accountingSystem) {
      case 4: return translation(15352)
      case 6: return translation(18138)
    }
    return ''
  }

  getRepairOrderAlias () {
    switch (this.props.auth.accountingSystem) {
      case 4: return translation(18149)
      case 6: return translation(18150)
    }
    return ''
  }

  render () {
    const {auth, item, dracarSettings} = this.props
    let isReady = (!hasAccess([6], auth.user.UserType) && item.ReadyForInvoice === 1 || hasAccess([6], auth.user.UserType) && item.ReadyForInvoiceByWP) && (!dracarSettings || dracarSettings.dracarActive)
    let isMarked = !hasAccess([6], auth.user.UserType) && item.IsMarkInvoiced || hasAccess([6], auth.user.UserType) && item.IsMarkInvoicedByWP
    let isInvoiced = !hasAccess([6], auth.user.UserType) && item.IsInvoiced || hasAccess([6], auth.user.UserType) && item.IsInvoicedByWP
    let isDraft = auth.departmentType !== 1 ? item.IsDraft : item.BodyShopIsDraft
    let isInsurance = item.OrderType === 1

    if (isDraft || (isInvoiced && isMarked)) return null

    let allowInvoicing = true
    let lastHistoryMessageKey = this.state.lastHistory ? this.state.lastHistory.MessageKey : ''
    if (this.state.lastHistory) {
      allowInvoicing = this.state.lastHistory.AllowInvoicing // if Body Paint partner has pricelist, AllowInvoicing is false
    }

    // let hasAddon = item.HasAddonPrice
    let isReset = item.InvoiceStatusIsResat

    const renderText = () => {
      return (
        <ResendText isLoadingLastHistory={this.state.isLoading} lastHistory={this.state.lastHistory} t={translation} store={store} />
      )
    }

    const renderConfirmApproveDialog = () => {
      return (
        <div>
          <ResendText isLoadingLastHistory={this.state.isLoading} lastHistory={this.state.lastHistory} t={translation} store={store} assessment />
        </div>
      )
    }

    const renderButtonText = (text) => {
      if (this.state.isLoading) {
        return (
          <span className='animated-background'>
            <i className='fa fa-spinner fa-spin fa-2x fa-fw' />
          </span>
        )
      }
      return text
    }

    let approveIcon = InvoiceIcons.Ready_Invoice
    if (!isDraft && isReset) {
      approveIcon = InvoiceIcons.Invoice_Reset_Approved
    }
    const dracarMessages = {
      MISSING_B2B: translation('17836').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()),
      NO_INTEGRATION: translation('16773').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()),
      ORDER_NOT_IN_KEYLOOP: translation('16609').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()),
      LAST_HISTORY: translation(this.state.lastHistory ? this.state.lastHistory.MessageKey : '').replace('[KeyLoopSystem]', this.getKeyLoopSystemName())
    }

    let isUsingKeyLoop = [4, 6].includes(this.props.auth.accountingSystem)
    let isDracarApprovalPending = dracarSettings && !isReady && !isDraft && !isInvoiced
    let isDracarInvoicingPending = dracarSettings && !isDraft && !isInvoiced

    return (
      <div className='poppedup padding invoiceInlinePopup form textLeft'>
        <Inline block fillChildNum={[1]} alignChildren={'bottom'}>
          <Icon icon={InvoiceIcons.Total_Price} />
          <h3>{translation('13486')}</h3>
          <CloseButton size='m' onClick={this.props.close} />
        </Inline>
        <Divider />
        {(isDracarApprovalPending && !isReset && !dracarSettings.isRpReport && !allowInvoicing) && <div className='dracar__approval dracar__red'>{dracarMessages.LAST_HISTORY}</div>}
        {(isDracarApprovalPending && !isReset && !dracarSettings.isRpReport && !dracarSettings.isDracarOtherOrder) && <div className='dracar__approval dracar__red'>{dracarMessages.MISSING_B2B}</div>}
        {(isDracarApprovalPending && !isReset && dracarSettings.isRpReport && !allowInvoicing) && <div className='dracar__approval dracar__red'>{dracarMessages.MISSING_B2B}</div>}
        {(isDracarInvoicingPending && dracarSettings.isDracarOtherOrder) && <div className='dracar__approval dracar__red'>{dracarMessages.NO_INTEGRATION}</div>}
        {(isDracarInvoicingPending && !dracarSettings.isDracarOtherOrder && !dracarSettings.dracarOrderSet) && <div className='dracar__approval dracar__red'>{dracarMessages.ORDER_NOT_IN_KEYLOOP}</div>}

        {(!isReady && !isDraft && !isInvoiced && isReset) && translation('15068')}
        {(!isReady && !isDraft && !isInvoiced && !isReset) && <Label>{translation('1140')}</Label>}
        { /* (hasAddon) && renderSplitAddonCheck() */ }
        <Inline block fillChildNum={[0]} alignChildren={'center'}>
          <Label>{translation('13502')}</Label>
          <Icon icon={approveIcon} />
          {isUsingKeyLoop && isDracarApprovalPending && allowInvoicing && ((dracarSettings.dracarOrderSet && (dracarSettings.isRpReport || isInsurance)) || dracarSettings.isDracarOtherOrder) && <Button spacing={0} size='m' onClick={() => this.checkApproveInvoice(false, true)} disabled={this.state.isLoading || (isReady && !isDraft && !isInvoiced)} labelText={renderButtonText(translation('752'))} style='link' />}
          {!isUsingKeyLoop && !isReady && !isDraft && !isInvoiced && allowInvoicing && <Button spacing={0} size='m' onClick={() => this.checkApproveInvoice(false, true)} disabled={this.state.isLoading || (isReady && !isDraft && !isInvoiced)} labelText={renderButtonText(translation('752'))} style='link' />}
        </Inline>
        <Inline block fillChildNum={[0]} alignChildren={'center'}>
          <Label>{translation('13503')}</Label>
          <Icon icon={InvoiceIcons.Sent_To_Invoice} />
          <Button spacing={0} size='m' onClick={() => this.invoiceOrder(false)} disabled={this.state.isLoading || isInvoiced || !isReady || (dracarSettings && dracarSettings.isDracarOtherOrder)} labelText={renderButtonText(translation('1301'))} style='link' />
        </Inline>
        <Inline block fillChildNum={[0]} alignChildren={'center'}>
          <Label>{translation('13505')}</Label>
          <Icon icon={InvoiceIcons.Invoiced} />
          <Button spacing={0} size='m' onClick={() => this.invoiceOrder(true)} disabled={this.state.isLoading || isMarked || isInvoiced || !isReady || (dracarSettings && dracarSettings.isDracarOtherOrder)} labelText={renderButtonText(translation('1301'))} style='link' />
        </Inline>
        <Inline block fillChildNum={[0]} alignChildren={'center'}>
          <Label>{translation('13504')}</Label>
          <Icon icon={InvoiceIcons.Marked_As_Invoice} />
          <Button spacing={0} size='m' onClick={() => this.markAsInvoiced()} disabled={this.state.isLoading || isMarked || !isReady} labelText={renderButtonText(translation('15046'))} style='link' />
        </Inline>
        {isReady && !isInvoiced && !isMarked && <a onClick={() => this.checkApproveInvoice(true)}>{translation('13515')}</a>}
        {this.state.showPopup === true && (
          <div>
            <Confirm
              t={translation}
              renderText={() => translation('14747')}
              confirm={this.confirm}
              notConfirm={this.notConfirm} />
          </div>
        )}
        {this.state.showAddonPopup === true && (
          <Confirm
            t={translation}
            renderText={() => translation('16485')}
            confirm={() => this.confirmAddon(true)}
            notConfirm={() => this.confirmAddon(false)} />
        )}
        {this.state.showResendPopup === true &&
          <Confirm
            t={translation}
            renderText={renderText}
            confirm={e => this.confirmResend(e)}
            notConfirm={this.notConfirm} />}
        {this.state.confirmApproveAssesment.open === true &&
          <Confirm
            t={translation}
            renderText={renderConfirmApproveDialog}
            confirm={this.approveInvoice.bind(this, false)}
            notConfirm={this.notConfirm} />}
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  invoiceOrder,
  approveOrderInvoice,
  markAsInvoiced,
  invoiceHistory
})(InvoicePopup)



// WEBPACK FOOTER //
// ./src/app/shared/components/InvoicePopup/index.js